/**
 * Moka API bilgileri yalnızca kayıtlı siteden açılan sayfayı kabul eder.
 * Ödeme başka bir origin'de başladıysa iframe orada basılmaz; tarayıcı
 * kayıtlı sitedeki köprü sayfasına gider.
 */
export function redirectToMokaHost(opts: {
  paymentHostUrl?: string | null;
  iframeUrl: string;
  returnUrl: string;
}): boolean {
  const host = (opts.paymentHostUrl || '').trim();
  if (!host || !opts.iframeUrl || !opts.returnUrl) return false;

  let origin: string;
  try {
    const parsed = new URL(host);
    if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') return false;
    origin = parsed.origin;
  } catch {
    return false;
  }

  if (origin === window.location.origin) return false;

  const bridge =
    `${origin}/#/pay/hosted` +
    `?src=${encodeURIComponent(opts.iframeUrl)}` +
    `&return=${encodeURIComponent(opts.returnUrl)}`;
  window.location.assign(bridge);
  return true;
}
